function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M256.5,286c76.683,0,142.5-64.228,142.5-142.5C399,64.9,335.1,0,256.5,0S113,64.9,113,143.5   c0,35.099,12.9,66.899,34.2,91.5c3.005-1.994,21.385-18.847,53.399-29.7C183.8,190,173,168.1,173,143.5   c0-45.601,37.899-82.5,83.5-82.5S339,97.899,339,143.5c0,44.65-35.839,82.5-82.5,82.5C181.597,226,113,288.457,113,368.5   c0,78.6,64.9,143.5,143.5,143.5S399,447.1,399,368.5c0-35.101-12.9-66.901-34.2-91.5c-3.005,1.994-21.385,18.845-53.399,29.7   C328.2,322,339,343.9,339,368.5c0,45.599-36.899,83.5-82.5,83.5S173,414.099,173,368.5C173,323.85,209.839,286,256.5,286z"
}));

var SvgLoop = function SvgLoop(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLoop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/loop.21dce757.svg";
export { ForwardRef as ReactComponent };